// Copy this code into your project file: RatificationSummary.jsx

import React, { useState, useEffect } from 'react';
import {
  Form,
  Card,
  Space,
  Radio,
  Row,
  Col,
  Statistic,
  DatePicker,
  message
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import {
  getAllEqpLogBooksdetails,
  getEquipmentLogBooksStats
} from '../../redux/slice';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import Layout from '@/common/Layout';
import { QrScanSingleShotModal } from '@/common/QrScan';
import { useDispatch } from 'react-redux';
import {
  QrcodeOutlined,
  CheckCircleOutlined,
  FileTextOutlined
  // PercentageOutlined
} from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const { RangePicker } = DatePicker;

const RatificationSummary = () => {
  const [form] = Form.useForm();
  const [allLogs, setAlllogs] = useState([]);
  // const [search, setSearch] = useState('');
  const [openCam, setOpenCam] = useState(false);

  // New state for the enhanced functionality
  const [selectionType, setSelectionType] = useState('all');
  const [equipmentId, setEquipmentId] = useState('');
  const [dateRange, setDateRange] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  console.log(allLogs);
  const dispatch = useDispatch();

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const type = urlParams.get('type');

  useEffect(() => {
    handleGetAllLogDetails();
  }, [type]);

  // Update form field when equipmentId changes
  useEffect(() => {
    if (equipmentId) {
      form.setFieldsValue({ equipmentId: equipmentId });
    }
  }, [equipmentId, form]);

  // Update form field when dateRange changes
  useEffect(() => {
    if (dateRange) {
      form.setFieldsValue({ dateRange: dateRange });
    }
  }, [dateRange, form]);

  const handleGetAllLogDetails = () => {
    const payload = {};
    dispatch(getAllEqpLogBooksdetails(payload)).then((response) => {
      if (response?.payload?.success) {
        setAlllogs(response?.payload?.data);
      }
    });
  };

  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      setEquipmentId(scanData.text);
      message.success(`Equipment scanned: ${scanData.text}`);
    }
  };

  // New submit handler for stats
  const handleSubmit = async () => {
    try {
      await form.validateFields();

      if (selectionType === 'specific' && !equipmentId) {
        message.error('Please scan equipment QR code');
        return;
      }

      if (!dateRange || !dateRange[0] || !dateRange[1]) {
        message.error('Please select date range');
        return;
      }

      setLoading(true);

      const startDate = dateRange[0].format('YYYY-MM-DD');
      const endDate = dateRange[1].format('YYYY-MM-DD');

      // Build API parameters
      const params = {
        start_date: startDate,
        end_date: endDate
      };

      if (selectionType === 'specific' && equipmentId) {
        params.equipment_id = equipmentId;
      }

      // TODO: Replace this with your actual API call
      // Example API call structure:
      dispatch(getEquipmentLogBooksStats(params)).then((response) => {
        if (response?.payload?.success) {
          setStats(response.payload.data);
        }
        setLoading(false);
      });

      // OR using fetch:
      // const queryString = new URLSearchParams(params).toString();
      // fetch(`prod_dispense/get-equipment-log-books-stats?${queryString}`)
      //   .then(response => response.json())
      //   .then(data => {
      //     setStats(data);
      //     setLoading(false);
      //   })
      //   .catch(error => {
      //     console.error('Error:', error);
      //     message.error('Failed to load stats');
      //     setLoading(false);
      //   });

      // Mock response for demonstration (REMOVE THIS IN PRODUCTION)
      // setTimeout(() => {
      //   const mockData = {
      //     total_entries: 145,
      //     total_ratifications: 132,
      //     accuracy_percentage: 91.03
      //   };
      //   setStats(mockData);
      //   setLoading(false);
      //   message.success('Stats loaded successfully');
      // }, 1000);
    } catch (error) {
      console.error('Validation error:', error);
      setLoading(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
    setSelectionType('all');
    setEquipmentId('');
    setDateRange(null);
    setStats(null);
    history.push('/equipment-log-book-list');
  };

  return (
    <>
      <Layout sider={false}>
        <Form form={form} layout="vertical">
          <Card
            title={<span>VIEW & DOWNLOAD AUDIT REPORT</span>}
            className={`${styles.cardStyles_approver}`}
          >
            {/* Radio Group for Report Type */}
            <Form.Item
              label="Select any one"
              name="reportType"
              rules={[{ required: true, message: 'Please select report type' }]}
              initialValue="all"
            >
              <Radio.Group
                onChange={(e) => {
                  setSelectionType(e.target.value);
                  setEquipmentId('');
                  setStats(null);
                  form.setFieldsValue({ equipmentId: '' });
                }}
                value={selectionType}
              >
                <Radio value="all">All Equipments</Radio>
                <Radio value="specific">Specific Equipment</Radio>
              </Radio.Group>
            </Form.Item>

            <Row gutter={16}>
              {/* Equipment Scanner - Only show for Specific Equipment */}
              {selectionType === 'specific' && (
                <Col xs={12} md={8}>
                  <Form.Item
                    label="Equipment ID"
                    name="equipmentId"
                    rules={[
                      {
                        required: selectionType === 'specific',
                        message: 'Please scan equipment'
                      }
                    ]}
                  >
                    <div>
                      <CustomButton
                        className={styles.qrcode}
                        onClick={() => setOpenCam(true)}
                        block
                      >
                        <QrcodeOutlined /> Scan by Equipment
                      </CustomButton>
                      {equipmentId && (
                        <div
                          style={{
                            marginTop: '8px',
                            padding: '8px 12px',
                            background: '#f0f9ff',
                            border: '1px solid #0ea5e9',
                            borderRadius: '6px',
                            color: '#0369a1',
                            fontWeight: 500
                          }}
                        >
                          Equipment ID: {equipmentId}
                        </div>
                      )}
                    </div>
                  </Form.Item>
                </Col>
              )}

              {/* Date Range Picker */}
              <Col xs={24} md={selectionType === 'specific' ? 8 : 8}>
                <Form.Item
                  label="Select start and end date"
                  name="dateRange"
                  rules={[
                    { required: true, message: 'Please select date range' }
                  ]}
                >
                  <RangePicker
                    style={{ width: '100%' }}
                    format="YYYY-MM-DD"
                    onChange={(dates) => setDateRange(dates)}
                    value={dateRange}
                    placeholder={['Start date', 'End date']}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Submit and Reset Buttons */}
            <FormItem className="text-center" style={{ marginTop: '16px' }}>
              <Space size="middle">
                <CustomButton
                  className={styles.inwardButton}
                  onClick={handleSubmit}
                  loading={loading}
                  type="primary"
                >
                  View
                </CustomButton>
                <CustomButton onClick={handleReset}>Back</CustomButton>
              </Space>
            </FormItem>
          </Card>
          <br />
          {stats && (
            <Card
              title={<span>Statistics Report</span>}
              className={`${styles.cardStyles_approver}`}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={8}>
                  <Card
                    bordered
                    style={{ textAlign: 'center', background: '#f0f9ff' }}
                  >
                    <Statistic
                      title="How many entries are made"
                      value={stats.total_entries}
                      prefix={<FileTextOutlined style={{ color: '#0ea5e9' }} />}
                      valueStyle={{ color: '#0369a1', fontWeight: 600 }}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={8}>
                  <Card
                    bordered
                    style={{ textAlign: 'center', background: '#f0fdf4' }}
                  >
                    <Statistic
                      title="How many ratifications are made"
                      value={stats.total_ratification_count}
                      prefix={
                        <CheckCircleOutlined style={{ color: '#10b981' }} />
                      }
                      valueStyle={{ color: '#059669', fontWeight: 600 }}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={8}>
                  <Card
                    bordered
                    style={{ textAlign: 'center', background: '#fef3c7' }}
                  >
                    <Statistic
                      title="Accuracy Percentage"
                      value={stats.accuracy_percentage}
                      suffix="%"
                      // prefix={
                      //   <PercentageOutlined style={{ color: '#f59e0b' }} />
                      // }
                      valueStyle={{ color: '#d97706', fontWeight: 600 }}
                      // precision={2}
                    />
                  </Card>
                </Col>
              </Row>
            </Card>
          )}

          {/* QR Scanner Modal */}
          <QrScanSingleShotModal
            title="Scan Equipment QR"
            visible={openCam}
            onCancel={() => setOpenCam(false)}
            hint="Point the camera at the equipment QR code."
            onScan={(decodedText) => handleQrScan({ text: decodedText })}
          />
        </Form>
      </Layout>
    </>
  );
};

export default RatificationSummary;
